export default __webpack_public_path__ + "static/media/yvotenaija.6c67534b.png";